export default "/images/vendor/flag-icon-css/flags/1x1/ws.svg?f06e3a3930f25859ac07ab5d271615e3";